import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { Auth } from '@angular/fire/auth';
import { SettingsService } from '../service/settings.service';
import { checkIfFisuDeactivateRole, checkIfFisuNotificationRole } from 'na-lib';

@Component({
    selector: 'app-redirect',
    templateUrl: './redirect.component.html',
    styleUrls: ['./redirect.component.css'],
    standalone: false
})
export class RedirectComponent {
  constructor(
    private router: Router,
    private auth: Auth,
    private settingsService: SettingsService
  ) {}

  async ngOnInit(): Promise<void> {
    await this.auth.authStateReady();

    if (!this.auth.currentUser?.uid) {
      this.router.navigate(['/logIn'], { replaceUrl: true });
      return;
    }

    const contextId = this.settingsService.contextId$;
    const user = this.settingsService.userAccount$;
    const fisuNotification = user && contextId && checkIfFisuNotificationRole(user, contextId);
    const fisuDeactivate = user && contextId && checkIfFisuDeactivateRole(user, contextId);

    if (fisuNotification) {
      this.router.navigate(['home', contextId, 'fisuNotificationContent'], { replaceUrl: true });
    } else if (fisuDeactivate) {
      this.router.navigate(['home', contextId, 'fisuDeactivateTridy'], { replaceUrl: true });
    } else {
      this.router.navigate(['/home'], { replaceUrl: true });
    }
  }
}
